import * as api from "services/api";
import { getErrors } from "helpers/error";

export const CREATE_PERMISSION = "[PERMISSION CREATE] CREATE_PERMISSION";
export const CREATE_PERMISSION_ERROR =
	"[PERMISSION CREATE] CREATE_PERMISSION_ERROR";
export const CREATE_PERMISSION_SUCCESS =
	"[PERMISSION CREATE] CREATE_PERMISSION_SUCCESS";

export const SET_VALUE = "[PERMISSION CREATE] SET_VALUE";
export const CLEAR_VALUES = "[PERMISSION CREATE] CLEAR_VALUES";

export function setValue(payload) {
	return dispatch => {
		dispatch({ type: SET_VALUE, payload });
	};
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function createPermission(model, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: CREATE_PERMISSION
		});

		try {
			const { login } = getState();

			let response = await api.sendPost(`/permission`, model, {
				Authorization: "Bearer " + login.token
			});

			if (response.ok) {
				let result = await response.json();
				dispatch({
					type: CREATE_PERMISSION_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				let result = await response.json();
				const errors = getErrors(result);

				dispatch({
					type: CREATE_PERMISSION_ERROR,
					payload: errors
				});

				callback && callback(errors);
			}
		} catch (error) {
			console.log(error);
			callback && callback(error);

			return dispatch({
				type: CREATE_PERMISSION_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
